import { createStyles, Grid, makeStyles, Theme } from "@material-ui/core"
import { FormWithRedirect, required, TextInput } from "react-admin"
import { JsonInput } from "react-admin-json-view"


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        fixed_fee: {},
        amount: { fontWeight: 'bold' },
        root: {
            flexGrow: 1,
        },
    })
)

const MerchantBanks = (props: any) => {
    const classes = useStyles()

    return <FormWithRedirect
        {...props}
        render={formProps => {
            // console.log(formProps.record)
            return (
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={12} sm={6} lg={4}>
                        <TextInput
                            source="account_number"
                            fullWidth
                            validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                        <TextInput
                            source="holder_name"
                            fullWidth
                            // validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                        <TextInput
                            source="data.rfc"
                            fullWidth
                            validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                        <TextInput
                            source="data.curp"
                            fullWidth
                            validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={8}>
                        <TextInput
                            source="name"
                            fullWidth
                            validate={[required()]}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                        <JsonInput
                            source="data"
                            fullWidth
                            jsonString={false} // Set to true if the value is a string, default: false
                            reactJsonOptions={{
                                // Props passed to react-json-view
                                name: null,
                                collapsed: true,
                                enableClipboard: false,
                                displayDataTypes: true,
                            }}
                        />
                    </Grid>
                </Grid>
            )
        }}
    />
}

export default MerchantBanks